import angular from 'angular';
import ContentService from './content.service';
'use strict';
var ValuepropbarComponent = /** @class */ (function () {
    /*@ngInject*/
    function ValuepropbarComponent(Content) {
        this.slides = [];
        var p = this;
        Content.getShipping().then(function (data) {
            p.slides.push(data.data.response);
        });
        Content.getEQP().then(function (data) {
            p.slides.push(data.data.response);
        });
        Content.getSupport().then(function (data) {
            p.slides.push(data.data.response);
        });
        this.currentIndex = 0;
    }
    ValuepropbarComponent.prototype.setCurrentSlideIndex = function (index) {
        //console.log(index, this.currentIndex);
        this.currentIndex = index;
    };
    ;
    ValuepropbarComponent.prototype.isCurrentSlideIndex = function (index) {
        return this.currentIndex === index;
    };
    ;
    ValuepropbarComponent.prototype.prevSlide = function () {
        this.currentIndex = (this.currentIndex < this.slides.length - 1) ? ++this.currentIndex : 0;
    };
    ;
    ValuepropbarComponent.prototype.nextSlide = function () {
        this.currentIndex = (this.currentIndex > 0) ? --this.currentIndex : this.slides.length - 1;
    };
    ;
    return ValuepropbarComponent;
}());
export { ValuepropbarComponent };
ValuepropbarComponent.$inject = ['Content'];
export default angular.module('directives.valuepropbar', ['ngSanitize'])
    .service('Content', ContentService)
    .component('valuepropbar', {
    template: require('./valuepropbar.html'),
    controller: ValuepropbarComponent
})
    .name;
//# sourceMappingURL=valuepropbar.component.js.map